import { COLORS } from '@shared/config/colors/colors';
import { baseShadowStyle } from '@shared/style/base-shadow';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    width: 100%;
    height: 100vh;
    justify-content: center;
    align-items: center;
    background-color: ${COLORS.newBg};
`;

export const Content = styled('div')`
    width: 500px;
    max-height: 80vh;
    margin: 20px;
    padding: 0 40px;
    background-color: ${COLORS.neutral_00};
    border-radius: 12px;
    overflow: auto;
    margin-bottom: auto;
    margin-top: auto;
    ${baseShadowStyle}
`;

export const ScrollOffset = styled('div')`
    display: flex;
    width: 100%;
    margin: 40px 0;
    gap: 20px;
    flex-direction: column;
    align-items: center;
`;

export const PreloaderWrapper = styled('div')`
    position: relative;
    width: 48px;
    height: 48px;
`;
